import { StyleSheet, View } from 'react-native';
import { colorList } from 'utils/colors';

const Divider = () => {

    return (
        <View style={styles.divider} />
    );
}

const styles = StyleSheet.create({
    divider: {
        height: 1,
        backgroundColor: colorList.GREY.primary,
        marginVertical: 4,
    },
});

export default Divider;